import { render } from "./PageStatus.vue?vue&type=template&id=151a06b8&ts=true"
import script from "./PageStatus.vue?vue&type=script&lang=ts"
export * from "./PageStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__